export enum SPOT_TRADE_MODE {
  Spot = 'Spot',
  Margin = 'Margin',
}
